var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.14 174.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.07,174.13c47.89,0,87.07-39.18,87.07-87.06C174.14,39.18,134.96,0,87.07,0,39.19,0,0,39.18,0,87.07c0,47.89,39.19,87.06,87.07,87.06ZM40.55,85.65c4.91-4.93,12.97-4.93,17.9,0l15.92,15.92v-59.58c0-7.08,5.69-12.77,12.77-12.77s12.58,5.69,12.58,12.77v59.58s15.92-15.92,15.92-15.92c4.93-4.93,12.97-4.93,17.89,0,2.57,2.55,3.74,5.89,3.74,9.04,0,3.35-1.17,6.48-3.74,9.05l-37.54,37.36c-.6.58-1.19,1.18-1.97,1.77-.21.19-.6.19-.8.39-.38.2-.98.58-1.36.58-.41.21-.79.39-1.19.39-.41.19-.78.4-1.18.4-1.56.39-3.34.39-4.91,0-.41,0-.8-.21-1.19-.4-.4,0-.78-.18-1.17-.39-.39,0-.79-.39-1.18-.58-.39-.2-.79-.2-1-.39-.77-.59-1.37-1.19-1.95-1.77l-37.56-37.36c-4.91-5.12-4.91-12.97,0-18.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.416d1a1cb0a814f2ee292fcdc4e4bd7e.svg";
export { ForwardRef as ReactComponent };